<template>
  <div
    v-if="loading">
      <Loader />
  </div>
  <div v-else>
    <Loader
      :soft="true"
      v-if="saving" />
    <div
      class="content">
      <Table
        ref="table"
        :columns="columns"
        :rows="list"
        :filters="filters"
        :totalRecords="list.length"
        :perpage="50"
      >
      </Table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    stylist: {
      default: null
    }
  },
  watch: {
    stylist () {
      this.load()
      for (var stylist of this.getStylists) {
        if (stylist.id == this.stylist) {
          this.$emit('change-stylist', stylist)
        }
      }
    },
    tab () {
      this.load()
    }
  },
  data: () => ({
    data: {},
    loading: false,
    saving: false
  }),
  computed: {
    ...mapGetters([
      'getStylists'
    ]),
    filters () {
      return {
      }
    },
    list () {
      const list = []
      console.log(this.data)
      for (var row of this.data) {
        row.cust = {
          type: 'customer',
          customer: row.customer
        }
        row.order = {
          type: 'order',
          order_id: row.id
        }
        row.menu = [
          {
            name: 'Go to styling',
            url: `/#/stylings/process?id=${row.id}&key=${row.key}`
          }
        ]
        list.push(row)
      }
      return list
    },
    columns () {
      const columns = {}

      columns.locale_id = {
        name: 'Country',
        type: 'flag'
      }

      columns.order = {
        name: 'Order'
      }

      columns.cust = {
        name: 'Customer'
      }

      columns.stylist_comment = {
        name: 'Stylist comment',
        width: 15
      }
      return columns
    }
  },
  methods: {
    updated () {
      this.load()
    },
    load () {
      Vue.$api.get('/stylist/orders/?stylist=' + this.stylist, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
          this.parse(data)
        }
      })
    },
    parse (data) {
      this.data = data
    },
    initFilter () {

    }
  },
  created () {
    this.load()
  }
}
</script>
